/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  // 生成随机时间
  function generateRandomTime() {
    var hours = Math.floor(Math.random() * 15) + 1
    var minutes = Math.floor(Math.random() * 60)
    var seconds = Math.floor(Math.random() * 60)
    //总共的毫秒数
    var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

    return targetTime
  }
  function TimeDown(value) {
    //倒计时的总秒数
    var totalSeconds = parseInt(value / 1000)
    //取模（余数）
    var modulo = totalSeconds % (60 * 60 * 24)
    //小时数
    var hours = Math.floor(modulo / (60 * 60))
    modulo = modulo % (60 * 60)
    //分钟
    var minutes = Math.floor(modulo / 60)
    //秒
    var seconds = modulo % 60

    hours = hours.toString().length == 1 ? '0' + hours : hours
    minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
    seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

    //输出到页面
    $('.sp_hour').html(hours)
    $('.sp_minute').html(minutes)
    $('.sp_second').html(seconds)
    //延迟一秒执行自己
    if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
    } else {
      setTimeout(function () {
        TimeDown(value - 1000)
      }, 1000)
    }
  }
  TimeDown(generateRandomTime())
  let spImgList = []
  new Swiper('.sp-swiper-fade', {
    // spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })
  new Swiper('.sp-swiper-fade2', {
    slidesPerView: 'auto',
    spaceBetween: 40,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 16500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  jQuery('.sp-scroll').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })
  jQuery('.sp-scroll2').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })
  $('.product-box .sp-opt').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    let _index = $(this).index()

    $(this)
      .parents('.product-box')
      .find('.sp-p-img')
      .eq([_index])
      .show()
      .siblings('.sp-p-img')
      .hide()
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let sptop =
          document.body.clientWidth <= 1080
            ? $('.sp-mobile .sp-fixed-top').height()
            : $('.sp-pc .sp-fixed-top').height()
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let prods = window.product
  function getCur(parentBox) {
    let option0 = parentBox.find('.sp-color .active').attr('data-val')
    let option1 = parentBox.find('.sp-size .active').attr('data-val')
    console.log(option0, option1, parentBox)
    return prods.filter(
      item => item.option1 == option0 && item.option2 == option1
    )[0]
  }
  function changePrice(parentBox) {
    let num = parentBox.find('#calcNumber').val() || 1
    let price = ((getCur(parentBox).price * num) / 100).toFixed(2)
    let compare = ((getCur(parentBox).compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    parentBox.find('.price1 span').html(price)
    parentBox.find('.price2 span').html(compare)

    let off_font =
      100 -
      Math.ceil(
        (getCur(parentBox).price / getCur(parentBox).compare_at_price) * 100
      )
    parentBox.find('.sp-frees span').html(off_font + '% OFF')
  }

  $('.sp-mobile .reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    const parentBox = $(this).parents('.product-part ')
    changePrice(parentBox)
  })
  $('.sp-mobile .add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    const parentBox = $(this).parents('.product-part ')
    changePrice(parentBox)
  })

  $('.sp-pc .reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    const parentBox = $(this).parents('.product-part ')
    changePrice(parentBox)
  })
  $('.sp-pc .add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    const parentBox = $(this).parents('.product-part ')
    changePrice(parentBox)
  })
  $('.sp-pc .product-box').click(function () {
    $(this).addClass('sp-active').siblings().removeClass('sp-active')
  })
  $('.sp-btn-style').click(function () {
    const parentBox = $(this).parents('.product-part')
    console.log(parentBox, '---')
    let num = parentBox.find('#calcNumber').val() || 1
    window.location.href = '/cart/' + getCur(parentBox).id + ':' + num
  })
  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
  // 产品切换
  var _index = 0
  $('.opt-group .option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
  })
  $('#color .option').click(function () {
    var index = $(this).index()
    var index2 = $('#Size .option.active').index()
    changeoption.call(this, index, index2)
  })
  $('#color2 .option').click(function () {
    var index = $(this).index()
    var index2 = $('#Size2 .option.active').index()
    changeoption.call(this, index, index2)
  })
  $('#Size .option').click(function () {
    var index = $('#color .option.active').index()
    var index2 = $(this).index()
    changeoption.call(this, index, index2)
  })
  $('#Size2 .option').click(function () {
    var index = $('#color2 .option.active').index()
    var index2 = $(this).index()
    changeoption.call(this, index, index2)
  })
  function changeoption(index, index2) {
    const parentBox = $(this).parents('.product-part ')
    changePrice(parentBox)
    $('.sp-mobile .sp-tops-img>img').hide()
    $('.sp-pc .sp-tops-img>img').hide()
    $('.sp-mobile .sp-tops-img .sp-tops-span').hide()
    $('.sp-pc .sp-tops-img .sp-tops-span').hide()
    var texts = $('#Size .option.active').text()
    var texts2 = $('#Size2 .option.active').text()
    _index = index2
    if (index2 == 0) {
      $('.sp-mobile .sp-tops-img .sp-tops-span').hide()
      $('.sp-pc .sp-tops-img .sp-tops-span').hide()
    } else {
      $('.sp-mobile .sp-tops-img .sp-tops-span').text(texts)
      $('.sp-pc .sp-tops-img .sp-tops-span').text(texts2)
      $('.sp-mobile .sp-tops-img .sp-tops-span').show()
      $('.sp-pc .sp-tops-img .sp-tops-span').show()
    }
    $('.sp-mobile .sp-tops-img>img').eq(_index).show()
    $('.sp-pc .sp-tops-img>img').eq(_index).show()
  }
  $('.sp-cart ').click(function () {
    window.location.href = '/cart'
  })
  // 加入购物车
  addCart()
  function addCart() {
    // 加入购物车
    $('.addCerts').click(function () {
      // do something here
      //   var number =
      //     Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
      //   $('.sp-cart #cardNum').html(number)
      const parentBox = $(this).parents('.product-part ')
      var data = {
        id: getCur(parentBox).id,
        quantity: parentBox.find('#calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('.sp-cart #cardNum').html(result.item_count)
            $('.sp-cart .num').css('background', '#cf0101')
          })
        },
        dataType: 'json',
      })

      var img = $('.sp-tops-img>img').eq(_index)
      if ($(this).hasClass('sp-pc')) {
        img = $('.sp-pc .sp-tops-img>img').eq(_index)
      } else {
        img = $('.sp-mobile .sp-tops-img>img').eq(_index)
      }
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.product-part').append(flyer)
      $('.clone').css({
        width: img.width(),
        height: img.height(),
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.sp-cart')[0].getBoundingClientRect()
      $('.sp-cart').addClass('shake')
      setTimeout(() => {
        $('.sp-cart').removeClass('shake')
      }, 1000)
      var finish
      var widths
      if ($(this).hasClass('sp-pc')) {
        finish = $('.sp-pc .sp-cart-pc')
        widths = $('.sp-pc .sp-cart-pc').width()
      } else {
        finish = $('.sp-mobile .sp-btn-style2 .sp-cart')
        widths = $('.sp-mobile .sp-btn-style2 .sp-cart').width()
      }
      $('.clone').animate(
        {
          top: $(this).hasClass('sp-pc') ? finish[0].offsetTop : '100%',
          left: $(this).hasClass('sp-pc')
            ? finish[0].offsetLeft + widths / 2 - 15
            : $('.sp-info2')[0].offsetLeft + $('.sp-info2').width() - 45,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
  }

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })
  // 初始隐藏按钮
  $('.sp-btn-style2').css('opacity', '0')
  $('.sp-btn-style2').css('pointer-events', 'none')
  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp-header').height() * $('div#root').css('zoom')
  ) {
    $('.sp-fixed-top').addClass('sp-fixed')
  } else {
    $('.sp-fixed-top').removeClass('sp-fixed')
  }

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp-header').height() * $('div#root').css('zoom')
    ) {
      $('.sp-fixed-top').addClass('sp-fixed')
    } else {
      $('.sp-fixed-top').removeClass('sp-fixed')
    }
    // 控制底部按钮显示/隐藏
    toggleBottomButton()
  })
  // 滚动显示底部按钮
  function toggleBottomButton() {
    const scrollTop = $(window).scrollTop()
    const windowHeight = $(window).height()
    const showScrollDistance = windowHeight * 0.5 // 滚动超过首屏高度的50%后显示

    if (scrollTop > showScrollDistance) {
      $('.sp-btn-style2').css('opacity', '1')
      $('.sp-btn-style2').css('pointer-events', 'auto')
      $('.sp-btn-style2').css('transition', 'opacity 0.3s ease')
    } else {
      $('.sp-btn-style2').css('opacity', '0')
      $('.sp-btn-style2').css('pointer-events', 'none')
    }
  }

  // 初始检查
  toggleBottomButton()
  // 问答
  $('.q-row').click(function () {
    $(this).parent().toggleClass('sp-show')
  })
  // 视频进入视口时自动播放
  const videos = document.querySelectorAll('.sp-video')
  const videoObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 视频进入视口时播放
          entry.target.play().catch(error => {
            // 如果自动播放失败（比如用户设置了阻止自动播放），静默处理
            console.log('视频自动播放失败:', error)
          })
        } else {
          // 视频离开视口时暂停
          entry.target.pause()
        }
      })
    },
    {
      threshold: 0.3, // 当视频30%可见时触发
    }
  )

  videos.forEach(video => {
    videoObserver.observe(video)
  })
  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }
})
